import React from 'react';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, modules, type ContentBlock } from '../data/modules';
import { OFFER_ANCHOR } from '../data/constants';
interface BlockCardProps {
  block: ContentBlock;
  variant: 'module' | 'bonus';
}
function BlockCard({
  block,
  variant
}: BlockCardProps) {
  const isBonus = variant === 'bonus';
  const Icon = isBonus ? GiftIcon : CheckCircle2Icon;
  return <article className={`flex h-full flex-col rounded-lg border-2 p-3.5 ${isBonus ? 'border-gold bg-espressoLight text-cream' : 'border-cinnamon/40 bg-white'}`} data-id="element-18" data-mp="1ds13j7zlcf2r">
      <h3 className={`flex items-start gap-2 text-base sm:text-lg ${isBonus ? 'text-gold' : 'text-espresso'}`} data-id="element-19" data-mp="1nq76zu11pt9q">
        <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${isBonus ? 'text-gold' : 'text-burnt'}`} aria-hidden="true" data-id="element-20" data-mp="1skunb5lwbhd8" />
        <span data-id="element-21" data-mp="342cktncvvkrb">{block.title}</span>
      </h3>
      <p className={`mt-1.5 text-sm font-bold ${isBonus ? 'text-cream' : 'text-cinnamon'}`} data-id="element-22" data-mp="3411dxeo55wvz">{block.lead}</p>
      <div className={`mt-1 space-y-1 text-sm font-medium leading-snug ${isBonus ? 'text-cream/80' : 'text-espresso/80'}`} data-id="element-23" data-mp="1bp5a7yi5i85l">
        {block.body.map(paragraph => <p key={paragraph} data-id="element-24" data-mp="12o7fy7xilf07">{paragraph}</p>)}
      </div>
      {block.close ? <p className="mt-auto pt-2 text-sm font-extrabold text-burnt" data-id="element-25" data-mp="xqfbkefoo0f4">{block.close}</p> : null}
    </article>;
}
export function ModulesSection() {
  return <section className="bg-cream px-4 py-6" data-id="element-26" data-mp="ssnllpylmodk">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="nzue4ubqx1xs">
        <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-28" data-mp="nxzurkg4hhvt">
          What&apos;s <span className="text-burnt" data-id="element-29" data-mp="j1j4okpd4tg3">Inside</span>
        </h2>
        <div className="mt-3 grid gap-3 md:grid-cols-2" data-id="element-30" data-mp="f07diaquc05s">
          {modules.map(block => <BlockCard key={block.title} block={block} variant="module" data-id="element-31" data-mp="a0uvc3awzh9j" />)}
        </div>
        <div className="mx-auto mt-4 max-w-md" data-id="element-32" data-mp="50oz09tp96l4">
          <CTAButton href={OFFER_ANCHOR} data-id="element-33" data-mp="5208mq9tt8k5">🍥 YES! I WANT TO START NOW</CTAButton>
        </div>
      </div>
    </section>;
}
export function BonusesSection() {
  return <section className="bg-espresso px-4 py-6" data-id="element-34" data-mp="dqwqhfe7mii">
      <div className="mx-auto max-w-5xl" data-id="element-35" data-mp="actz82thbaj">
        <h2 className="text-center text-xl text-gold sm:text-3xl" data-id="element-36" data-mp="3hlw1cbhd89cd">🎁 5 Premium Bonuses Included</h2>
        <div className="mt-3 grid gap-3 md:grid-cols-2" data-id="element-37" data-mp="3mkysqt4fah1v">
          {bonuses.map(block => <BlockCard key={block.title} block={block} variant="bonus" data-id="element-38" data-mp="e55dsipqpdmx" />)}
        </div>
      </div>
    </section>;
}